import React from 'react'

function SkillCapsule(props) {
    return (
        <div className="skill">
            {props.text}
        </div>
    )
}

export default SkillCapsule
